<script setup lang="ts">
import type { TServiceStep } from "@/assets/js/types";

defineProps<{
	steps: TServiceStep[];
}>();
</script>
<template>
	<div class="wrapp-steps">
		<div class="wrapp-content">
			<step v-for="(val, index) in steps" :key="index" :step="val" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.wrapp-steps {
	background: #0d1015;
	border-bottom-left-radius: 32px;
	border-bottom-right-radius: 32px;

	.wrapp-content {
		width: 100%;
		max-width: 1142px;
		margin: auto;
		display: flex;
		// padding: 122px 0;
		padding: 80px 0;
		gap: 20px;
		justify-content: center;
	}
}

@media screen and (width <= 768px) {
	.wrapp-steps {
		.wrapp-content {
			width: 100%;
			margin: auto;
			display: flex;
			flex-direction: column;
			padding: 40px 16px;
			gap: 40px;
		}
	}
}
</style>
